import React, { Component } from 'react';
import { BlipChat } from "blip-chat-widget";

import './style.css';
import settings from '../../config/default.json'

class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            birthDate: '',
            privacyCheckbox: false,
            intentionCheckbox: false,
            nameValid: true,
            emailValid: true,
            phoneValid: true,
            birthDateValid: true,
            privacyValid: true,
            dateError: ''
        }

        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.uuidv4 = this.uuidv4.bind(this);
        this.bot = settings.bot
        document.getElementById('logo').href = this.bot.logo;
    }

    handleChange(event) {
        const nameValidation = /\d|\[|\]|´|`|~|:|\.|,|,|º|\\|\/|\(|\)|-|_|\+|\*|\?|;|=|!|@|#|$|%|¨|&|>|<|'|"/gi
        const name = event.target.name;
        let value = null;

        if (name === 'privacyCheckbox' || name === 'intentionCheckbox')
            value = event.target.checked;
        else
            value = event.target.value;

        if (name === 'phone') {
            let phone = '';
            if (event.target.value.length === 14) {
                phone = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,4})(\d{0,4})/);
            }
            else {
                phone = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
            }
            value = '(' + phone[1] + ') ' + phone[2] + (phone[3] ? '-' + phone[3] : '');
        }
        else if (name === 'birthDate') {
            let date = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
            value = (date[2] ? date[1] + '/' : date[1]) + (date[3] ? date[2] + '/' : date[2]) + date[3];
        }
        else if (name === 'name') {
            value = event.target.value.replace(nameValidation, '')
        }

        this.setState({ [name]: value });
    }

    validateForm() {
        this.setState({
            formValid: this.state.emailValid && this.state.email !== '' &&
                this.state.nameValid && this.state.name !== '' &&
                this.state.phoneValid && this.state.phone !== '' &&
                this.state.birthDateValid && this.state.birthDate !== '' &&
                this.state.privacyValid
        }, this.blipChat);
    }

    //generates randon id to be used on every component
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r && 0x3 | 0x8);
            return v.toString(16);
        });
    }

    async blipChat() {
        if (this.state.formValid) {

            var blipClient = new BlipChat()
                .withAppKey(this.bot.key)
                .withTarget('blip')
                .withAuth({
                    authType: BlipChat.DEV_AUTH,
                    //temporary solution
                    userIdentity: this.state.email.replace("@", ""),
                    userPassword: this.state.email.replace("@", ""),
                })
                .withAccount({
                    fullName: this.state.name,
                    email: this.state.email,
                    phoneNumber: this.state.phone,
                    extras:
                    {
                        birthDate: this.state.birthDate,
                        privacyPolicy: this.state.privacyCheckbox,
                        inemail: this.state.intentionCheckbox,
                        inemailDate: new Date(Date.now()).toLocaleString('pt-BR')
                    }
                })
                .withEventHandler(
                    BlipChat.CREATE_ACCOUNT_EVENT,
                    function () {
                        blipClient.sendMessage({
                            "type": "text/plain",
                            "content": "Olá."
                        })
                    }
                )
                .withCustomCommonUrl(settings.bot.chatUrl)

            await blipClient.build();
            await this.updateContact();
        }
    }

    async updateContact() {
        if (this.bot.domain.includes('nestledolcegusto')) {
            const hasContact = await this.getContact();

            if (hasContact) {
                fetch(this.bot.baseUrl, {
                    method: 'post',
                    headers: new Headers({
                        'Authorization': this.bot.authKey,
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        id: this.uuidv4(),
                        method: 'merge',
                        uri: '/contacts',
                        type: 'application/vnd.lime.contact+json',
                        resource: {
                            identity: encodeURIComponent(this.state.email.replace("@", "")) + this.bot.domain,
                            extras: {
                                inemail: this.state.intentionCheckbox ? 'S' : 'N',
                                inemailDate: new Date(Date.now()).toLocaleString('pt-BR')
                            }
                        }
                    })
                });
            }
        }
    }

    async getContact() {
        return await fetch(this.bot.baseUrl, {
            method: 'post',
            headers: new Headers({
                'Authorization': this.bot.authKey,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                id: this.uuidv4(),
                method: 'get',
                uri: '/contacts/' + encodeURIComponent(encodeURIComponent(this.state.email.replace("@", ""))) + this.bot.domain
                //uri needs email with %2540 to correct escape '@'
            })
        })
            .then(response => response.json())
            .then(body => {
                return body.status.toString() === "success"
            })
            .catch(() => {
                return false;
            })
    }

    validate() {
        let nameValid = this.state.nameValid;
        let emailValid = this.state.emailValid;
        let phoneValid = this.state.phoneValid;
        let birthDateValid = this.state.birthDateValid;
        let privacyValid = this.state.privacyCheckbox;

        nameValid = (this.state.name !== "" &&
            this.state.name.length > 3 &&
            this.state.name.indexOf(" ") !== -1 &&
            this.state.name.split(" ")[1] &&
            this.state.name.split(" ")[0].length > 2);

        emailValid = this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

        phoneValid = this.state.phone.length === 15 || this.state.phone.length === 14;

        var date = this.state.birthDate.split('/')
        date = `${date[1]}/${date[0]}/${date[2]}`
        var birthDate = new Date(date);
        birthDate.setMonth(birthDate.getMonth() + 1);

        if (!isNaN(birthDate.getTime())) {
            birthDateValid = ((new Date().getFullYear() - birthDate.getFullYear()) > 13 && birthDate.getFullYear() > 1900) ||
                ((new Date().getFullYear() - birthDate.getFullYear()) === 13 &&
                    birthDate.getMonth() < new Date().getMonth()) ||
                (birthDate.getMonth() === new Date().getMonth() && birthDate.getDay() >= new Date().getDay() + 1)
            if (!birthDateValid) {
                this.setState({ dateError: 'É necessário ter no mínimo 13 anos para prosseguir.' });
            }
        }
        else {
            birthDateValid = false;
            this.setState({ dateError: 'O formato enviado é inválido, por favor tente novamente.' });
        }

        this.setState({
            nameValid: nameValid,
            emailValid: emailValid,
            phoneValid: phoneValid,
            birthDateValid: birthDateValid,
            privacyValid: privacyValid
        }, this.validateForm);
    }

    render() {
        return (

            <div id="blip">
                <form className="form">
                    <h2>Faça o Login.</h2>
                    <h4>Por favor, preencha seus dados nos campos abaixo.</h4>
                    <div>
                        <div>
                            {this.state.nameValid ? null : <label className="error">⚠ É necessário preencher seu nome completo.</label>}
                        </div>
                        <label className="fields">Nome:</label>
                        <input
                            type="text"
                            placeholder="Seu nome"
                            value={this.state.name}
                            onChange={this.handleChange}
                            name="name"
                            required
                        />
                    </div>
                    <div>
                        <div>
                            {this.state.emailValid ? null : <label className="error">⚠ E-mail inválido</label>}
                        </div>
                        <label className="fields">E-Mail:</label>
                        <input
                            type="text"
                            placeholder="Seu e-mail"
                            value={this.state.email}
                            onChange={this.handleChange}
                            name="email"
                            required
                        />
                    </div>
                    <div>
                        <div>
                            {this.state.phoneValid ? null : <label className="error">⚠ Telefone inválido</label>}
                        </div>
                        <label className="fields">Telefone:</label>
                        <input
                            type="text"
                            placeholder="Seu telefone"
                            value={this.state.phone}
                            onChange={this.handleChange}
                            name="phone"
                            required
                        />
                    </div>
                    <div>
                        <div>
                            {this.state.birthDateValid ? null : <label className="error">⚠ {this.state.dateError}</label>}
                        </div>
                        <label className="fields">Data Nascimento:</label>
                        <input
                            type="text"
                            placeholder="Sua data de nascimento"
                            value={this.state.birthDate}
                            onChange={this.handleChange}
                            name="birthDate"
                            required
                        />
                    </div>
                    <div className="checkbox">
                        <input name="intentionCheckbox" onChange={this.handleChange} type="checkbox"></input>
                        <label className="checkbox">Concordo em receber futuras informações da nestlé por e-mail</label>
                    </div>
                    <div className="checkbox">
                        <div>
                            {this.state.privacyValid ? null : <label className="error">⚠ É necessário aceitar a política de privacidade para continuar.</label>}
                        </div>
                        <input name="privacyCheckbox" onChange={this.handleChange} type="checkbox"></input>
                        <label className="checkbox">Sim, li e aceito a <a target="blank" href="https://www.nestle.com.br/politica-de-privacidade">política de privacidade</a> da nestlé</label>
                    </div>
                </form>
                <button onClick={this.validate}>Entrar no chat</button>
            </div>
        )
    }
}

export default Form;